import { useSyncExternalStore } from 'react';

export type ThemePref = 'system' | 'light' | 'dark';
const KEY = 'logbook.theme';

function read(): ThemePref {
  try {
    const v = localStorage.getItem(KEY);
    return v === 'light' || v === 'dark' ? v : 'system';
  } catch {
    return 'system';
  }
}

let pref: ThemePref = read();
const subs = new Set<() => void>();

function apply() {
  const root = document.documentElement;
  if (pref === 'system') root.removeAttribute('data-theme');
  else root.setAttribute('data-theme', pref);
}
apply();

export function setTheme(next: ThemePref) {
  pref = next;
  try {
    if (next === 'system') localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, next);
  } catch {
    /* private mode */
  }
  apply();
  subs.forEach((f) => f());
}

/** Cycle system -> light -> dark -> system. */
export function cycleTheme() {
  setTheme(pref === 'system' ? 'light' : pref === 'light' ? 'dark' : 'system');
}

export function useTheme(): ThemePref {
  return useSyncExternalStore(
    (cb) => { subs.add(cb); return () => subs.delete(cb); },
    () => pref,
    () => pref,
  );
}
